import React from 'react';
import { typography } from '../../styles/design-tokens';

export const DocumentsTabSkeleton: React.FC = () => {
  return (
    <div className="space-y-6 w-full">
      <div className="bg-white rounded-2xl p-6 border border-[#E4E8EA] animate-pulse">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
          <div className="flex items-center gap-2">
            <div className="h-6 w-32 bg-gray-200 rounded-md"></div>
            <div className="h-5 w-16 bg-gray-100 rounded-md"></div>
          </div>
          <div className="h-10 w-40 bg-gray-200 rounded-md"></div>
        </div>

        <div className="space-y-4">
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              className="bg-[#F5F8F9] rounded-xl p-4 border border-[#E4E8EA]"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                <div>
                  <div className="h-4 w-16 bg-gray-200 rounded mb-2"></div>
                  <div className="h-5 w-32 bg-gray-100 rounded"></div>
                </div>
                <div>
                  <div className="h-4 w-16 bg-gray-200 rounded mb-2"></div>
                  <div className="h-5 w-24 bg-gray-100 rounded"></div>
                </div>
                <div>
                  <div className="h-4 w-16 bg-gray-200 rounded mb-2"></div>
                  <div className="h-5 w-28 bg-gray-100 rounded"></div>
                </div>
                <div className="min-w-0">
                  <div className="h-4 w-16 bg-gray-200 rounded mb-2"></div>
                  <div className="space-y-2">
                    {[...Array(2)].map((_, i) => (
                      <div key={i} className="flex items-start gap-2">
                        <div className="h-4 w-4 bg-gray-200 rounded-full mt-1"></div>
                        <div className="h-5 w-48 bg-gray-100 rounded"></div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
